import Animated from '../../../../components/essence/animated/animated';
import { useNavigate } from 'react-router-dom';
import { useExpenseContext } from '../../../../contexts/expense/expense-context';
import accountService from '../../../../shared/services/account-service';
interface Props {
	circleId: string;
}
export default function AddNewExpense({ circleId }: Props) {
	const navigate = useNavigate();
	const { setExpense } = useExpenseContext();

	const goToAddExpenses = () => {
		const account = accountService.getAccount();
		if (account) {
			const loggedInUserId = account.id;
			setExpense({
				id: '',
				dateTime: new Date(),
				currency: '₹',
				circleId: circleId,
				createdById: loggedInUserId,
				isSettlement: false,
				description: '',
				amount: '',
				creditors: [],
				debtors: [],
			});
		}
		navigate(`/secure/circles/${circleId}/add-expense/expense-detail`);
	};
	return (
		<Animated>
			<div className="headline-4 lowercase" onClick={goToAddExpenses}>
				+ add expense
			</div>
		</Animated>
	);
}
